<div *ngIf="question">
<div class="card">
    <h6 class="card-header text-center" [appMath]="title"></h6>
    <div class="card-body">
        <div class="text-center question-title gold-bg" >
            <a [routerLink]="['/student/quiz/review',learner.server_student_user_id,quizEnvelop.server_quiz_envelop_id]"
            class="btn btn-outline-primary">Back to Start
        </a>
            Question  {{ questionIndex+1 }} of {{ quizEnvelop.question_count }}
            <a [routerLink]="['/student/quiz/review',learner.server_student_user_id, quizEnvelop.server_quiz_envelop_id]"
            class="btn btn-outline-primary">Back to Start
        </a>
        </div>
        <div class="questionholder">
            <div class="form-group row">
                <div class="text-center question-body" >
                    <app-revise-question *ngIf="question"
                     [question]="question">
                    </app-revise-question>
                  </div>
            </div>

        </div>
    </div>
    </div>

    <div class="row" *ngIf ="quizEnvelop.questions.length>0" class="mt-2">
        <div  class="col-sm-12 text-center">
        <button *ngIf ="questionIndex==0" class="btn btn-secondary btn-lg me-3"><i class="fa fa-angle-double-left"></i> Back</button>
        <button *ngIf="questionIndex!=0"
        (click)="movePrevious()"
            class="backnav btn btn-primary btn-lg me-3"><i
            class="fa fa-angle-double-left"></i> Previous Question
        </button>
        <a [routerLink]="['/student/quiz/review',learner.server_student_user_id,quizEnvelop.server_quiz_envelop_id]"
            class="btn btn-primary btn-lg me-3">Close</a>
        <button *ngIf="(questionIndex+1)!=quizEnvelop.question_count"
            (click)="moveNext()"
            class="forwardnav btn btn-primary btn-lg">Next Question <i class="fa fa-angle-double-right"></i>
        </button>
    </div>
    </div>

</div>
<app-spinner *ngIf="loading"></app-spinner>

